export default __webpack_public_path__ + "static/media/default-user.7a69ff0b.svg";